import { groq } from "next-sanity"

import { AppSettings } from "@/settings"

import { checkPermissions, validateAccessRightsToCustomer } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"
import { visitReportAttachmentsProjection } from "../sanity/visitReport.projection"

export const queryVisitReportAttachment = {
  async visitReportAttachment(parent, args, context, info) {
    const { lang = AppSettings.defaultLocale(), visitReportId, cdn = false, attachmentId } = args
    const { user } = context
    await checkPermissions({
      user,
      domainObject: DomainObjects.VISIT_REPORTS,
      operation: Operations.READ,
    })

    const client = context.sanityClient
    client.config({
      ...AppSettings.sanityConfigByLang(lang),
      useCdn: cdn,
    })

    const draftsFilter = `&& !(_id in path("drafts.**"))`

    const visitReport = await client.fetch(
      groq`*[_type=="visitReport" && _id==$id ${draftsFilter}][0] {
        ${visitReportAttachmentsProjection()}
      }`,
      { id: visitReportId, attachmentKey: attachmentId },
    )
    if (!visitReport) {
      return null
    }

    await validateAccessRightsToCustomer({
      user: user,
      customerNumber: visitReport.customerNumber,
    })

    return visitReport?.attachments?.find((attachment) => attachment.id === attachmentId)
  },
}
